const stats = [
  { num: '+3', label: 'Años en el mercado' },
  { num: '10/10', label: 'Calificación de clientes' },
  { num: '10+', label: 'Líneas de producto' },
  { num: '100%', label: 'Precios competitivos' },
];

export default function About() {
  return (
    <section id="nosotros" className="about">
      <div className="about-split">
        <div className="about-split-text">
          <span className="about-badge">⚙ Quiénes Somos</span>
          <h2 className="about-title">
            Distribuidora <span>DAET</span> —<br />
            Acero al mejor precio
          </h2>
          <p className="about-text">
            DAET Aceros Económicos de Tepa se presenta en el mercado de Tepatitlán
            de Morelos como una opción focalizada en un atributo clave: el precio.
            Ser conocido como un proveedor "económico" es un poderoso imán para
            constructores, herreros y talleres que buscan optimizar costos sin
            sacrificar la calidad del material.
          </p>
          <p className="about-text">
            Desde constructores que requieren varilla y perfiles estructurales,
            hasta el herrero artesanal que fabrica puertas, ventanas y protecciones
            —DAET es la parada obligatoria para cotizar materiales en la región.
          </p>
          <button
            className="btn btn-primary"
            style={{ marginTop: '12px' }}
            onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Solicitar cotización
          </button>
        </div>

        <div className="about-split-stats">
          {stats.map(({ num, label }) => (
            <div key={label} className="about-split-stat">
              <span className="about-split-stat-num">{num}</span>
              <span className="about-split-stat-label">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
